var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericPage',[_c('template',{slot:"breadcrumb-items"},[_c('li',{staticClass:"active bold"},[_vm._v("Modelo de Riesgos")])]),_c('template',{slot:"title"},[_vm._v(" El proceso de evaluación, selección y calificación. ")]),_c('template',{staticClass:"text-generic",slot:"body"},[_c('ScoreContent')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }